import { useState } from 'react';
import base from '../styles/Base.module.css';

const MetafieldItem = ({
  title,
  content,
  mf,
  content2,
  allergy_note,
  isSetItem,
}: {
  title?: string;
  content?: string;
  mf?: any;
  content2?: string;
  allergy_note?: string;
  isSetItem?: boolean;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  //  アコーディオンに表示させたくない項目
  const hiddenTitles = [
    'アレルギー成分補足文言',
    'レシピ_1_画像',
    'レシピ_2_画像',
    'レシピ_1_タイトル',
    'レシピ_2_タイトル',
    'レシピ_1_材料',
    'レシピ_2_材料',
    'レシピ_1_作り方',
    'レシピ_2_作り方',
    'レシピ_1_概要',
    'レシピ_2_概要',
    '商品ストーリーについて_本文',
    '商品ストーリーについて_タイトル',
    '商品ストーリーについて_画像',
  ];
  console.log('title', title);
  console.log('isSetItem', isSetItem);
  console.log('mf', mf);
  console.log(
    'titleはあるのないの',
    title === 'アレルギー成分補足文言' ||
      title === 'レシピ_1_画像' ||
      title === 'レシピ_2_画像' ||
      title === 'レシピ_1_タイトル' ||
      title === 'レシピ_2_タイトル' ||
      title === 'レシピ_1_材料' ||
      title === 'レシピ_2_材料' ||
      title === 'レシピ_1_作り方' ||
      title === 'レシピ_2_作り方' ||
      title === 'レシピ_1_概要' ||
      title === 'レシピ_2_概要' ||
      title === '商品ストーリーについて_本文' ||
      title === '商品ストーリーについて_タイトル' ||
      title === '商品ストーリーについて_画像' ||
      title === 'セット内容' ||
      title === '原材料',
  );

  if (!title || hiddenTitles.includes(title)) {
    return <></>;
  }
  return (
    <div>
      <div className={base.modalContentMetaFieldItem}>
        <div className={base.modalContentMetaFieldItemLabel} onClick={() => setIsExpanded(!isExpanded)}>
          <p className={`${base.modalContentMetaFieldItemLabelText} ${isExpanded ? base.open : ''}`}>{title}</p>
          <svg
            aria-hidden="true"
            focusable="false"
            role="presentation"
            className={`${base.modalContentMetaFieldItemLabelIcon} ${isExpanded ? base.open : ''}`}
            viewBox="0 0 10 6"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
        {isSetItem ? (
          <div className={`${base.modalContentMetaFieldItemContent} ${isExpanded ? base.open : ''}`}>
            {title === 'セット内容' && (
              <>
                <ul className={base.productSetItemList}>
                  {mf.set_products &&
                    mf.set_products.map((a: any, ind: number) => (
                      <li key={`${title}_${a.title}_${ind}`}>
                        <a className={base.productSetItemLink} href={a.url} target="_blank" rel="noreferrer">
                          {a.title}
                        </a>
                      </li>
                    ))}
                </ul>
                <p className={base.productSetItemText}>{content}</p>
              </>
            )}
            {title === '原材料' && (
              <>
                <ul className={base.productSetItemList}>
                  {mf.set_products &&
                    mf.set_products.map((a: any, ind: number) => (
                      <li key={`${title}_${a.title}_${ind}`}>
                        <a className={base.productSetItemLink} href={a.url} target="_blank" rel="noreferrer">
                          {a.title}
                        </a>
                        <p className={base.productSetItemText}>{a.ingredients}</p>
                      </li>
                    ))}
                </ul>
              </>
            )}
          </div>
        ) : (
          <div className={`${base.modalContentMetaFieldItemContent} ${isExpanded ? base.open : ''}`}>
            {content ? <div dangerouslySetInnerHTML={{ __html: content }}></div> : ''}
            {allergy_note && title === 'アレルギー表示' ? <div className={base.allergyNote}>{allergy_note}</div> : ''}
            {title === 'アレルギー表示' && (
              <ul className={base.productAllergyList}>
                {mf.allergy_items &&
                  mf.allergy_items.map((a: any, ind: number) => (
                    <li
                      key={`${title}_${a.title}_${ind}`}
                      className={`${base.productAllergyItem} ${a.content ? `${base.exists}` : ''}`}
                    >
                      {a.title}
                    </li>
                  ))}
              </ul>
            )}
            {content2 ? <div>{content2}</div> : ''}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetafieldItem;
